export default __webpack_public_path__ + "static/media/img6.bc969e5e.png";